<script lang="ts">
import IconClose from 'virtual:icons/lucide/x'

import IconButton from '@/components/core/IconButton.svelte'
import Tooltip from '@/components/Tooltip.svelte'
import { testIds } from '@/constants'
import { t } from '@/modules/translations'

type Props = {
	onClick: () => void
}

const { onClick }: Props = $props()
</script>

<div class="absolute right-3 top-3 text-neutral-500">
	<Tooltip content={$t('tooltip.close')} placement="bottom" delay={1000}>
		<IconButton icon={IconClose} iconDescription="Close" {onClick} size="md" testId={testIds.buttonCloseDrawer} />
	</Tooltip>
</div>
